import * as yup from "yup";

export const validationSchema = yup.object({
  name: yup.string("Enter name").required("Name is required"),
  companyName: yup
    .string("Enter company name")
    .required("Company name is required"),
  email: yup.string("Enter email").required("Email is required"),
  phone: yup.string("Enter phone").required("Phone is required"),
  leadType: yup.string("Enter lead type").required("Lead type is required"),
  industry: yup.string("Enter industry").required("Industry is required"),
});
